import { useState, useCallback, useEffect, useRef } from 'react';

export const useReasoningTimer = () => {
  const activeIntervals = useRef(new Set());
  useEffect(() => {
    const intervals = activeIntervals.current;
    return () => { intervals.forEach(clearInterval); intervals.clear(); };
  }, []);
  const [reasoningTimers, setReasoningTimers] = useState({});

  const startThinkingTimer = useCallback((messageId) => {
    setReasoningTimers((prev) => {
      // If there's already a timer or it was completed, do nothing
      if (prev[messageId]?.intervalId || prev[messageId]?.isComplete) {
        return prev;
      }
      const startTime = Date.now();
      const intervalId = setInterval(() => {
        setReasoningTimers((current) => {
          const currentObj = current[messageId];
          if (!currentObj || currentObj.isComplete) {
            // If somehow ended or doesn't exist, stop
            clearInterval(intervalId);
            activeIntervals.current.delete(intervalId);
            return current;
          }
          const elapsedSeconds = (Date.now() - currentObj.startTime) / 1000;
          return {
            ...current,
            [messageId]: {
              ...currentObj,
              elapsed: elapsedSeconds,
            },
          };
        });
      }, 100);
      activeIntervals.current.add(intervalId);

      return {
        ...prev,
        [messageId]: {
          startTime,
          elapsed: 0,
          intervalId,
          isComplete: false,
        },
      };
    });
  }, []);

  const stopThinkingTimer = useCallback((messageId) => {
    setReasoningTimers((prev) => {
      const timerObj = prev[messageId];
      if (timerObj && timerObj.intervalId) {
        clearInterval(timerObj.intervalId);
        activeIntervals.current.delete(timerObj.intervalId);
        return {
          ...prev,
          [messageId]: {
            ...timerObj,
            isComplete: true,
          },
        };
      }
      return prev;
    });
  }, []);

  const clearAllTimers = useCallback(() => {
    setReasoningTimers((prev) => {
      Object.values(prev).forEach((timer) => {
        if (timer.intervalId) {
          clearInterval(timer.intervalId);
          activeIntervals.current.delete(timer.intervalId);
        }
      });
      return {};
    });
  }, []);

  return {
    reasoningTimers,
    startThinkingTimer,
    stopThinkingTimer,
    clearAllTimers
  };
};